"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5219],{

/***/ 55219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ Pager; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./main/javascripts/styles/base/spaceStyle.ts
var spaceStyle = __webpack_require__(96749);
// EXTERNAL MODULE: ./main/javascripts/styles/base/colorStyle.ts
var colorStyle = __webpack_require__(80910);
;// CONCATENATED MODULE: ./main/javascripts/constants/PagerConstants.ts
var MAX_DISP_NUM = 3;
var BUTTON_SIZE = "1.42rem";
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/pager/ClickableElement.tsx






var ClickableElement = function ClickableElement(props) {
  var onClick = function onClick() {
    props.handler(props.pageNum);
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
    onClick: onClick,
    css: [liStyle, liClickableStyle,  true ? "" : 0,  true ? "" : 0],
    role: "button",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
      css: aClickableStyle,
      children: props.children
    })
  });
};
var liStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("border-radius:50%;text-align:center;cursor:pointer;padding:", spaceStyle/* space.atom */.D.atom, ";width:", BUTTON_SIZE, ";height:", BUTTON_SIZE, ";line-height:", BUTTON_SIZE, ";" + ( true ? "" : 0),  true ? "" : 0);
var liClickableStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("transition:background 0.4s ease;&:hover{background-color:", (0,colorStyle/* hex2rgba */.rW)(colorStyle/* accentColor.primaryColor */.z.primaryColor, 0.1), ";}&:active{background-color:", (0,colorStyle/* hex2rgba */.rW)(colorStyle/* accentColor.primaryColor */.z.primaryColor, 0.1), ";}" + ( true ? "" : 0),  true ? "" : 0);
var aClickableStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("color:", colorStyle/* accentColor.primaryColor */.z.primaryColor, ";" + ( true ? "" : 0),  true ? "" : 0);
;// CONCATENATED MODULE: ./main/javascripts/components/pager/DisabledElement.tsx






var DisabledElement = function DisabledElement(props) {
  var children = props.children,
      _props$styleKey = props.styleKey,
      styleKey = _props$styleKey === void 0 ? "default" : _props$styleKey;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
    css: DisabledElement_liStyle[styleKey],
    children: children
  });
};
var liBaseStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("border-radius:50%;text-align:center;cursor:pointer;padding:", spaceStyle/* space.atom */.D.atom, ";width:", BUTTON_SIZE, ";height:", BUTTON_SIZE, ";line-height:", BUTTON_SIZE, ";" + ( true ? "" : 0),  true ? "" : 0);
var DisabledElement_liStyle = {
  "default": /*#__PURE__*/(0,emotion_react_browser_esm.css)(liBaseStyle, ";" + ( true ? "" : 0),  true ? "" : 0),
  active: /*#__PURE__*/(0,emotion_react_browser_esm.css)(liBaseStyle, ";background-color:", colorStyle/* accentColor.primaryColor */.z.primaryColor, ";color:#fff;cursor:default;" + ( true ? "" : 0),  true ? "" : 0),
  ellipsis: /*#__PURE__*/(0,emotion_react_browser_esm.css)(liBaseStyle, ";cursor:default;color:#aaa;width:1rem;padding-right:0;padding-left:0;" + ( true ? "" : 0),  true ? "" : 0)
};
// EXTERNAL MODULE: ./main/javascripts/components/icon/Icon.tsx
var Icon = __webpack_require__(65147);
// EXTERNAL MODULE: ./main/javascripts/styles/base/typographyStyle.ts
var typographyStyle = __webpack_require__(36716);
;// CONCATENATED MODULE: ./main/javascripts/components/pager/Pager.tsx
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var Pager = function Pager(props) {
  var totalNum = props.totalNum,
      numPerPage = props.numPerPage;

  var getPager = function getPager() {
    var totalPageCount = Math.ceil(totalNum / numPerPage);
    var page;

    if (props.page < 1) {
      page = 1;
    } else if (props.page > totalPageCount) {
      page = totalPageCount;
    } else {
      page = props.page;
    }

    var maxPagerDispNum = props.maxPagerDispNum ? props.maxPagerDispNum : MAX_DISP_NUM;
    var range = Math.round((maxPagerDispNum - 1) / 2);
    var pageLinks = [];
    pageLinks.push(getBackLiElement(page));

    if (page - range > 1) {
      pageLinks.push(getLiElement(1));

      if (page - range - 1 !== 1) {
        pageLinks.push((0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DisabledElement, {
          styleKey: "ellipsis",
          children: "..."
        }, 2));
      }
    }

    var firstPage = Math.max(page - range, 1);
    var lastPage = Math.min(page + range, totalPageCount);

    for (var _pageNum = firstPage; _pageNum <= lastPage; _pageNum += 1) {
      if (_pageNum === page) {
        pageLinks.push((0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DisabledElement, {
          styleKey: "active",
          children: _pageNum
        }, _pageNum));
      } else {
        pageLinks.push(getLiElement(_pageNum));
      }
    }

    if (totalPageCount > page + range) {
      if (page + range + 1 !== totalPageCount) {
        pageLinks.push((0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DisabledElement, {
          styleKey: "ellipsis",
          children: "..."
        }, totalPageCount - 1));
      }

      pageLinks.push(getLiElement(totalPageCount));
    }

    pageLinks.push(getNextLiElement(totalPageCount, page));
    return pageLinks;
  };

  var getLiElement = function getLiElement(pageNum) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ClickableElement, {
      handler: props.handler,
      pageNum: pageNum,
      children: pageNum
    }, pageNum);
  };

  var getBackLiElement = function getBackLiElement(page) {
    var back;

    if (page > 1) {
      var backPageNum = page - 1;
      back = (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ClickableElement, {
        handler: props.handler,
        pageNum: backPageNum,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: arrowStyle,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* Icon */.J, {
            styleKey: "arrowLeft"
          })
        })
      }, 0);
    } else {
      back = (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DisabledElement, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: [arrowStyle, arrowDisabledStyle,  true ? "" : 0,  true ? "" : 0],
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* Icon */.J, {
            styleKey: "arrowLeft"
          })
        })
      }, 0);
    }

    return back;
  };

  var getNextLiElement = function getNextLiElement(totalPageCount, page) {
    var next;

    if (page < totalPageCount) {
      var nextPageNum = page + 1;
      next = (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ClickableElement, {
        handler: props.handler,
        pageNum: nextPageNum,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: arrowStyle,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* Icon */.J, {
            styleKey: "arrowRight"
          })
        })
      }, totalPageCount + 1);
    } else {
      next = (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DisabledElement, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: [arrowStyle, arrowDisabledStyle,  true ? "" : 0,  true ? "" : 0],
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* Icon */.J, {
            styleKey: "arrowRight",
            size: ""
          })
        })
      }, totalPageCount + 1);
    }

    return next;
  };

  var pageLinks = getPager();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("nav", {
    role: "navigation",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ul", {
      css: ulStyle,
      children: pageLinks
    })
  });
};
var ulStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("display:flex;justify-content:space-between;list-style-type:none;padding:0;margin:0;font-size:", typographyStyle/* fontSize.body */.JB.body, ";line-height:", typographyStyle/* lineHeight.body1 */.Nv.body1, ";" + ( true ? "" : 0),  true ? "" : 0);
var arrowStyle =  true ? {
  name: "7q4cns",
  styles: "font-size:14px;padding:3px 4px 5px;display:flex"
} : 0;
var arrowDisabledStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("opacity:0.3;color:", colorStyle/* accentColor.primaryColor */.z.primaryColor, ";" + ( true ? "" : 0),  true ? "" : 0);

/***/ })

}]);